import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';

interface item{
  item: number,
  nombre: string,
  cantidad: number,
  precio: number,
  total: number
}

@Component({
  selector: 'app-mdl-create-p-item',
  imports: [CommonModule, FormsModule],
  templateUrl: './mdl-create-p-item.html',
  styleUrl: './mdl-create-p-item.css'
})
export class MdlCreatePItem implements OnInit {

  public p_item: item [] = [];
  private alertService = inject(AlertService);

  constructor(
    public mdl: MatDialogRef<MdlCreatePItem>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: Api
  ){}

  ngOnInit(): void {
    this.addPartida();
  }

  closeMdl(){
    this.mdl.close(); 
  }

  addPartida(){
    const newItem: item = {
      item: this.p_item.length + 1,
      nombre: '',
      cantidad: 1,
      precio: 0,
      total: 0
    };
    this.p_item.push(newItem);
  }

  removePartida(index: number){
    if (this.p_item.length > 1) {
      this.p_item.splice(index, 1);
      this.p_item.forEach((item, idx) => {
        item.item = idx + 1;
      });
    }
  }

  calculateTotal(index: number){
    const item = this.p_item[index];
    item.total = item.cantidad * item.precio;
  }

  getTotalGeneral(): number {
    return this.p_item.reduce((sum, item) => sum + item.total, 0);
  }

  hasValidPartidas(): boolean {
    const partidasConDatos = this.p_item.filter(item => 
      item.nombre.trim() !== '' && item.precio > 0
    );
    return partidasConDatos.length > 0;
  }

  savePartidas(){
    console.log(this.data);
    const partidasConDatos = this.p_item.filter(item => 
      item.nombre.trim() !== '' && item.precio > 0
    );
    
    if (partidasConDatos.length === 0) {
      this.alertService.warning('Validación requerida', 'Debe completar al menos una partida con nombre y precio válido.');
      return;
    }
    
    console.log('Partidas a guardar:', partidasConDatos);
    this.saveProducts();
  }

  saveProducts() {
    const partidasConDatos = this.p_item.filter(item => 
      item.nombre.trim() !== '' && item.precio > 0
    );
    
    if (partidasConDatos.length === 0) {
      this.alertService.warning('Selección requerida', 'Selecciona al menos un producto');
      return;
    }

    const payload = {
      presupuesto_id: this.data?.presupuestoId || this.data?.id,
      productos: partidasConDatos.map((item) => ({
        producto_servicio: item.nombre,
        cantidad: item.cantidad || 1,
        precio_unitario: item.precio, 
        iva_aplicable: true,
      })),
      cambio_descripcion: 'Se agregaron productos desde el manager',
    };
    
    console.log('📦 Payload enviado:', payload);

    this.api.addProductsBudget(payload).subscribe({
      next: (res) => {
        this.alertService.success('Productos guardados', 'Los productos se agregaron correctamente al presupuesto');
        this.mdl.close(res);
      },
      error: (err) => {
        console.error('❌ Error guardando productos:', err);
        this.alertService.error('Error al guardar', 'Error al guardar los productos. Intenta nuevamente.');
      },
    });
  }
}
